import { render, staticRenderFns } from "./Campo2L.vue?vue&type=template&id=e1d366b4&scoped=true&"
import script from "./Campo2L.vue?vue&type=script&lang=js&"
export * from "./Campo2L.vue?vue&type=script&lang=js&"
import style0 from "./Campo2L.vue?vue&type=style&index=0&id=e1d366b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1d366b4",
  null
  
)

export default component.exports